import React from 'react'
import { object } from 'prop-types'
import { Fieldset as Group } from 'react-redux-form/immutable'
import { Fieldset, Row, Field } from 'react-gridforms'

import Input from 'components/Input'

const FormHeader  = ({ data }) => {
  let status = <span className="text-warning">Pending</span>
  if (data.get('is_registered')) {
    status = <span className="text-success">Registered {data.get('registered_date')}</span>
  } else if (!data.get('has_applied')) {
    status = <span className="text-danger">Not applied</span>
  }
  const legend = (
    <div className="text-right">
      <span>{data.get('sy')} - {data.get('sem')} ({status})</span>
    </div>
  )
  return (
    <Fieldset legend={legend} disabled>
      <Group model=".header">
        <Row>
          <Field>
            <Input model=".student_id" label="ID Number"/>
          </Field>
          <Field span="3">
            <Input model=".last_name" label="Last Name"/>
          </Field>
          <Field span="4">
            <Input model=".first_name" label="First Name"/>
          </Field>
          <Field span="3">
            <Input model=".middle_name" label="Middle Name"/>
          </Field>
          <Field>
            <Input model=".suffix_name" label="Ext"/>
          </Field>
        </Row>
        <Row>
          <Field span="3">
            <Input model=".course_code" label="Course/Major"/>
          </Field>
          <Field>
            <Input model=".level" label="Year Level"/>
          </Field>
          <Field span="3">
            <Input model=".college_code" label="College"/>
          </Field>
          <Field span="4">
            <Input model=".scholarship_code" label="Scholarship"/>
          </Field>
          <Field>
            <Input model=".sex" label="Sex"/>
          </Field>
        </Row>
      </Group>
    </Fieldset>
  )
}

FormHeader.propTypes = {
  data: object,
}

export default FormHeader



// WEBPACK FOOTER //
// ./src/containers/COR/form-header.js